var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 19.8V21.3C14.7 22.3 13.9 23.1 12.9 23.1C11.9 23.1 11.1 22.3 11.1 21.3V19.8M16.4 6.10001C15.5 5.40001 14.7 5.20001 14.7 5.20001V4.8C14.7 3.8 13.9 3 12.9 3C11.9 3 11.1 3.8 11.1 4.8V5.20001C11.1 5.20001 7.89998 6.10001 7.09998 9.60001C6.29998 13.1 6.2 17.2 4 19.7H21.8",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1799 19.9254V21.4179C11.1799 22.4129 11.9888 23.209 13 23.209C14.0112 23.209 14.8203 22.4129 14.8203 21.4179V19.9254M14.8203 5V5.39802C14.8203 5.39802 18.0562 6.29354 18.8652 9.77612C19.6742 13.2587 19.7753 17.3383 22 19.8259H4",
    stroke: "#FF5800",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonotification);
export default __webpack_public_path__ + "static/media/nonotification.bf3e76bd0f35616823ac6ba780702628.svg";
export { ForwardRef as ReactComponent };